<template>
  <div class="app-module-header">
    <!-- Banner -->
    <!--    <ModuleBanner v-if="banner !== undefined" :img="banner"></ModuleBanner>-->
    <div>
      <!-- 大标题 -->
      <span class="app-module-header-title-h1">{{ title }}</span>
      <!-- 小简介 -->
      <span class="app-module-header-title-detail">{{ detail }}</span>
      <!-- 更多 -->
      <p class="app-module-header-title-more" v-on:click="goto(url)">了解更多 >></p>
    </div>
  </div>
</template>

<script>

export default {
  name: "ModuleHeader",
  props: {
    banner: String,
    title: String,
    detail: String,
    url: String,
  }, methods: {
    goto(url) {
      if (url !== undefined && url !== '') {
        this.$router.push(url);
      }
    }
  }
}
</script>

<style scoped>

.app-module-header {
  position: relative;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 15px;
  text-align: left;
}

.app-module-header-title-h1 {
  font-size: 25px;
  letter-spacing: 10px;
}

.app-module-header-title-detail {
  font-size: 15px;
  color: #6d6d6d;
}

.app-module-header-title-more {
  position: absolute;
  bottom: 25px;
  right: 0;
  font-size: 17px;
  cursor: pointer;
}

.app-module-header-title-more:hover {
  transition: all 200ms ease-out;
  color: #ff8a00;
}

</style>